import styled, { css, keyframes } from 'styled-components';

import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';
import { Card } from 'src/app/components/Elements/Card';
import type { ThemeSpaceType, ThemeType } from 'src/styles/theme';

const expandCardNoGap = (paddingTopBottom: ThemeSpaceType, paddingLeftRight: ThemeSpaceType, theme: ThemeType) => {
  return keyframes`
    0% {
      padding: ${theme.space.none} ${paddingLeftRight};
      border-bottom-width: 0rem;
    }
    100% {
      padding: ${paddingTopBottom} ${paddingLeftRight};
      border-bottom-width: ${theme.borderWidths.small};
    }
  `;
};

export const StyledCard = styled(props => <Card {...props} />)`
  background-color: ${props => props.theme.colors.white};
  padding: ${props => props.theme.space.s5};
  box-sizing: border-box;
  text-align: left;
  margin-bottom: ${props => (props.variant === 'condensed' ? props.theme.space.none : props.theme.space.s5)} !important;
  &:last-of-type {
    margin-bottom: ${props => props.theme.space.s5} !important;
  }

  ${props =>
    props.cardExpand &&
    css`
      animation-delay: ${props.theme.animationDelays[0]};
      animation-duration: ${props.theme.animationDurations[500]};
      animation-fill-mode: forwards;
      animation-name: ${expandCardNoGap(props.theme.space.s5, props.theme.space.s5, props.theme)};
    `}

  ${props =>
    props.variant === 'condensed' &&
    css`
      &:not(:last-child) {
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
      }
      &:not(:first-child) {
        margin-top: ${props => props.theme.space.none} !important;
        border-top-width: ${props => props.theme.space.none};
        border-top-right-radius: 0;
        border-top-left-radius: 0;
      }
    `}

  ${props =>
    props.design === 'pills' &&
    css`
      padding: ${props => props.theme.space.s7};
      position: relative;
      overflow: hidden;
      ${props.cardExpand &&
      css`
        animation-name: ${expandCardNoGap(props.theme.space.s7, props.theme.space.s7, props.theme)};
      `}
    `}

  ${props => props.theme.mediaQueries.mediumDown} {
    ${props => props.design === 'pills' && `padding: ${props.theme.space.s7} ${props.theme.space.s5};`}
    ${props =>
      props.design === 'pills' &&
      props.cardExpand &&
      css`
        animation-name: ${expandCardNoGap(props.theme.space.s7, props.theme.space.s5, props.theme)};
      `}
  }
`;

export const InnerAnimatedContent = styled.div<{ innerCardExpand: boolean }>`
  width: 100%;
  height: 100%;
  flex-grow: 1;
  position: relative;
  ${props =>
    props.innerCardExpand &&
    css`
      opacity: ${props.theme.opacities.none};
      animation-delay: ${props.theme.animationDelays[0]}, ${props.theme.animationDelays[200]};
      animation-duration: ${props.theme.animationDurations[1000]};
      animation-fill-mode: forwards;
      animation-name: expand-height, fade-in;
    `}
`;

export const YellowPillDesign = styled(props => <CapsuleIcon {...props} />)`
  position: absolute;
  width: 4rem;
  height: 9rem;
  fill: ${props => props.theme.colors.capsuleYellow} !important;
  transform: rotate(-30deg);
  top: -2.2rem;
  right: 7rem;
  ${props => props.theme.mediaQueries.mediumDown} {
    top: -2.8rem;
    right: 3rem;
  }
`;

export const LightGreenPillDesign = styled(props => <CapsuleIcon {...props} />)`
  position: absolute;
  width: 7.5rem;
  height: 7.5rem;
  fill: ${props => props.theme.colors.capsuleGreen10} !important;
  transform: rotate(-65deg);
  top: 0.5rem;
  left: -2.5rem;
  ${props => props.theme.mediaQueries.mediumDown} {
    top: -3.5rem;
    left: 0rem;
  }
`;

export const GreenPillDesign = styled(props => <CapsuleIcon {...props} />)`
  position: absolute;
  width: 7.5rem;
  height: 7.5rem;
  fill: ${props => props.theme.colors.capsuleGreen50} !important;
  transform: rotate(-20deg);
  bottom: -2rem;
  right: 1rem;
  ${props => props.theme.mediaQueries.mediumDown} {
    bottom: -3rem;
    right: -2.3rem;
  }
`;
